export { default } from "./vehicle-type-form";
